module.exports = __webpack_public_path__ + "static/media/starterguide7v2.74ecb81c.png";